import { useMemo } from 'react';
import type { ChartId } from '../catalog/chartCatalog';
import type { ChartResult } from '../catalog/types';
import { useIssueChartRuntime } from './issue/IssueChartRuntimeContext';
import { useInspectionChartRuntime } from './inspection/InspectionChartRuntimeContext';

export function useChartResultsMap(): Readonly<
  Partial<Record<ChartId, ChartResult>>
> {
  const issueRuntime = useIssueChartRuntime();
  const inspectionRuntime = useInspectionChartRuntime();

  return useMemo(
    () => ({
      ...issueRuntime.results,
      ...inspectionRuntime.results,
    }),
    [issueRuntime.results, inspectionRuntime.results]
  );
}
